/* eslint-disable no-tabs */
/* eslint-disable object-curly-newline */
/* eslint-disable linebreak-style */
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { formActions } from '../../../Actions';
import GeneralDetails from '../../../Components/Forms/Cooking Stations/GeneralDetails';
import { ViewPageHeader } from '../../../Components/Headers';
import {
	StyledTab,
	StyledTabs,
	TabPanel,
} from '../../../Components/StyledTabs';
import { generateDisabledProps, history, isEmpty } from '../../../Helpers';
import CookingStationsConfig from './CookingStation.config';

const TABS = ['GENERAL DETAILS'];

const CookingStationViewPage = (props) => {
	const { data, deleteStation, fetchStation, breadcrumbs } = props;

	const [state, setState] = useState({
		activeTab: 0,
		fields: _.cloneDeep(CookingStationsConfig.initialState.fields),
	});
	const { id } = useRouteMatch().params;
	useEffect(() => {
		fetchStation({
			entity: 'COOKING_STATIONS',
			req: {
				params: {
					id,
				},
			},
			method: 'VIEW',
		});
	}, []);

	useEffect(() => {
		if (!isEmpty(data)) {
			setState(CookingStationsConfig.serializer(state, data));
		}
	}, [data]);

	const { activeTab, fields } = state;

	const handleTabChange = (event, tab) => {
		setState({
			...state,
			activeTab: tab,
		});
	};

	const renderInfo = (idx) => {
		switch (idx) {
			case 0:
				return <GeneralDetails isDisabled fields={fields} />;

			default:
				return <></>;
		}
	};

	const { url } = useRouteMatch();

	const redirectToEdit = () => {
		const splitURL = url.split('/view');
		splitURL.splice(1, 0, '/edit');
		const newURL = splitURL.join('');
		history.push(newURL);
	};
	const handleDelete = () => {
		const splitURL = url.split('/view');
		deleteStation({
			entity: 'COOKING_STATIONS',
			req: {
				params: {
					id,
				},
			},
			method: 'DELETE',
		});
		history.push(splitURL[0]);
	};
	return (
		<div className='root'>
			<ViewPageHeader
				heading='View Cooking Station'
				handleEdit={redirectToEdit}
				handleDelete={handleDelete}
				breadcrumbs={[
					...breadcrumbs,
					{
						link: '',
						name: `View ${state.fields.name}`,
					},
				]}
				showBreadcrumbs
			/>
			<StyledTabs value={activeTab} onChange={handleTabChange}>
				{TABS.map((tab) => {
					return <StyledTab label={tab} />;
				})}
			</StyledTabs>
			{TABS.map((tab, idx) => {
				return (
					<TabPanel value={activeTab} index={idx}>
						<fieldset
							{...generateDisabledProps(true)}
							className='form-fieldset row'
							style={{
								alignItems: 'flex-start',
							}}
						>
							{renderInfo(idx)}
						</fieldset>
					</TabPanel>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.COOKING_STATIONS.data.VIEW;
	// const data = CookingStationsConfig.api;
	return {
		data,
	};
};

const mapDispatchToProps = {
	fetchStation: formActions.gateway,
	deleteStation: formActions.gateway,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CookingStationViewPage);
